// The green check a verified casting director gets, next to the project title
// on the casting-calls list and the boost page. Unverified directors get
// nothing: the absence is the signal, not a warning.

import React from "react";
import styled from "styled-components";
import i18next from "i18next";

const VerifiedCheck: React.FC<{ size?: number }> = ({ size = 16 }) => {
  const label = String(i18next.t("Verified casting director"));
  return (
    <Badge role="img" aria-label={label} title={label}>
      <svg viewBox="0 0 16 16" width={size} height={size} aria-hidden="true" focusable="false">
        <circle cx="8" cy="8" r="8" fill="#1f9d55" />
        <path
          d="M4.6 8.3l2.2 2.2 4.6-4.8"
          fill="none"
          stroke="#ffffff"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Badge>
  );
};

const Badge = styled.span`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  line-height: 0;
`;

export default VerifiedCheck;
